// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".diff-menu .el-menu-item{display:flex;justify-content:space-between;align-items:center;padding-right:10px}.diff-menu .el-menu-item .menu-name{width:160px}.diff-menu .el-menu-item .operation{height:100%;margin:0}", ""]);
// Exports
module.exports = exports;
